module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cQOW5"))).then(() => parcelRequire('hEqeo'));